import { BRAND, type Unit } from "@/data/units";

/** Preserva as UTMs de origem quando existirem na URL atual. */
function currentUtms(): Record<string, string> {
  if (typeof window === "undefined") return {};
  const params = new URLSearchParams(window.location.search);
  const out: Record<string, string> = {};
  for (const key of ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "gclid", "fbclid"]) {
    const v = params.get(key);
    if (v) out[`inbound_${key}`] = v;
  }
  return out;
}

export type LpLinkOptions = {
  campaign: string;
  content: string;
  unit?: Unit["lpParam"];
};

/** URL da landing page de captação (Day Use Nook), sempre com UTMs. */
export function lpUrl({ campaign, content, unit }: LpLinkOptions): string {
  const params = new URLSearchParams();
  if (unit) params.set("unit", unit);
  params.set("utm_source", "nookgym_site");
  params.set("utm_medium", "referral");
  params.set("utm_campaign", campaign);
  params.set("utm_content", content);
  for (const [k, v] of Object.entries(currentUtms())) params.set(k, v);
  return `${BRAND.lp}/?${params.toString()}`;
}

export function whatsappUrl(unit: Unit): string {
  const text = encodeURIComponent(unit.whatsappMessage);
  return `https://api.whatsapp.com/send/?phone=${unit.whatsapp}&text=${text}&type=phone_number&app_absent=0`;
}
